export const BASE_URL = import.meta.env.VITE_APP_API_URL;
export const CALENDAR_GOLANG_BASE_URL = import.meta.env.VITE_APP_CALENDAR_GOLANG_ENDPOINT;

export const getAvailableSlotsEndpoint = `${BASE_URL}/event-types-by-slug`;
export const bookEventEndpoint = `${BASE_URL}/booked-events`;
export const smartSchedulingEndpoint = `${CALENDAR_GOLANG_BASE_URL}/public/smart-scheduling`;
